import { AutomationRuleActionFilterInterface } from 'modules/automation-rules/actions/types/automation-rule-action-filter-interface'

export const defaultActionFilters: AutomationRuleActionFilterInterface = {
  actionCampaignId: undefined,
  actionCourseBundleId: undefined,
  actionCourseId: undefined,
  actionCommunityId: undefined,
  actionMailingId: undefined,
  actionTagId: undefined,
  actionSpecificMailingId: undefined,
  locale: undefined,
  webhookUrl: undefined,
  pipelineId: undefined,
  pipelineStageId: undefined,
  actionSmsTemplateId: undefined,
}
